import React from 'react';
import { faCheckCircle, faTimesCircle, IconDefinition } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styled from 'styled-components';

export interface Props {
  submissionError?: Error,
  hideErrorDetails?: boolean,
  errorMessageComponent?: React.ComponentType,
  messages?: IMessages,
}

interface IMessage {
  text: string,
  icon: IconDefinition,
}
interface IMessages {
  success: IMessage
  failure: IMessage
}


export const defaultMessages: IMessages = {
  success: {
    text: 'Message sent successfully!',
    icon: faCheckCircle,
  },
  failure: {
    text: 'Error!',
    icon: faTimesCircle,
  },
};


const SubmissionMessage:React.FC<Props> = ({
  submissionError,
  hideErrorDetails = false,
  errorMessageComponent,
  messages = defaultMessages,
}) => {
  const activeMessage: IMessage = submissionError
    ? messages.failure
    : messages.success;

  const ErrorMessage = errorMessageComponent || ErrorMessageDefault;
  return (
    <SubmissionMessageOuter>
      <Message className={submissionError ? 'failure' : 'success'}>
        <IconWrap>
          <FontAwesomeIcon icon={activeMessage.icon} />
        </IconWrap>
        <Text>{activeMessage.text}</Text>
      </Message>
      {typeof submissionError !== 'undefined' && !hideErrorDetails && (
        <ErrorMessage>{submissionError.message}</ErrorMessage>
      )}
    </SubmissionMessageOuter>
  );
};
export default SubmissionMessage;

const SubmissionMessageOuter = styled.div``;
const Message = styled.div`
  display: flex;
  align-items: center;
`;
const IconWrap = styled.span`
  margin-right: 0.5em;
`;
const Text = styled.span``;
const ErrorMessageDefault = styled.pre`
  margin: 0;
  margin-top: 0.5em;
  font-size: 1rem;
  color: red;
`;
